import React from "react";
import ReactDOM from 'react-dom/client';
import './index.css'
import App from './App.tsx'
import outputs from "../amplify_outputs.json";
import { Amplify } from 'aws-amplify';

// Import i18n - react-i18next
import './utils/i18n/i18n.js';
import { Authenticator } from "@aws-amplify/ui-react";
import setupAmplifyI18n from "./utils/i18n/I18nAmplifyUIForAuth.ts";
import { initializeViewportCssVariables } from "./utils/ui/ViewportUtils.ts";
import ClientDeviceUtils from "./utils/client/ClientDeviceUtils.ts";

// This allows listener in public user profile to be called
import "./utils/PublicUserProfileUtils.ts"

Amplify.configure(outputs);

// Amplify i18n used only for Amplify login/user related views
setupAmplifyI18n();

// Keep CSS variables in sync with the visual viewport (mobile URL bar hide/show)
initializeViewportCssVariables();

// Apply a root CSS class to distinguish mobile vs desktop for styling decisions
(() => {
  const root = document.documentElement;
  const isMobile = ClientDeviceUtils.isMobileDevice();
  root.classList.toggle('mobile-device', isMobile);
  root.classList.toggle('desktop-device', !isMobile);
})();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Authenticator.Provider>
      <App />
    </Authenticator.Provider>
  </React.StrictMode>,
);
